"use client";

import dynamic from "next/dynamic";
import type { ActivityData } from "@/app/actions/activity";

// Leaflet touches `window` at module evaluation, so it must never be
// loaded during server rendering (same pattern as BrowseMapWrapper).
const MapClient = dynamic(() => import("./MapClient"), {
  ssr: false,
  loading: () => (
    <div className="min-h-screen bg-warm-bg pt-16">
      <div className="w-full h-[70vh] bg-cream animate-pulse" />
    </div>
  ),
});

export function MapClientWrapper({ data }: { data: ActivityData }) {
  return <MapClient data={data} />;
}
